// extracted by mini-css-extract-plugin
export default {"container":"HS","promoapplied":"IS","tobeapplied":"JS","hr":"KS","teal":"LS","promoappliedcontainer":"MS","error":"NS","input":"OS","errorInput":"PS","promo_x":"QS","promo_info":"RS","promoxcontainer":"SS"};
    if(module.hot) {
      // 1730991509259
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  